import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import {
  Card,
  Icon,
  Stack,
} from '@openedx/paragon';
import { Check, Locked } from '@openedx/paragon/icons';

import TranslationDisclaimer from './TranslationDisclaimer';
import messages from './messages';

const LockedLanguages = ({ courseEnabledLanguages, originalCourseLanguage }) => {
  const { formatMessage } = useIntl();
  return (
    <Card>
      <Card.Body>
        {courseEnabledLanguages.map(({ code, localeName }) => {
          const availableIcon = code === 'en' ? (
            <Icon src={Check} className="text-success-500" aria-label="available" />
          ) : (
            <Icon src={Locked} aria-label="locked" />
          );
          return (
            <div key={`${code}-option`}>
              <Card.Section className="small">
                <Stack direction="horizontal" gap={3}>
                  {code === originalCourseLanguage ? formatMessage(messages.originalLanguageLabel) : localeName}
                  {availableIcon}
                </Stack>
              </Card.Section>
              <Card.Divider />
            </div>
          );
        })}
        <Card.Section>
          <TranslationDisclaimer isAuditMode />
        </Card.Section>
      </Card.Body>
    </Card>
  );
};

LockedLanguages.propTypes = {
  courseEnabledLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  originalCourseLanguage: PropTypes.string.isRequired,
};

export default LockedLanguages;
